export default __webpack_public_path__ + "static/media/download-on-app-store.8c4986ee.svg";